<template>
  <div class="searchpanel">
    <b-form inline>
      <DatepickerWithDropdown
        class="datepicker"
        :range="search.issue_date"
        :selected="this.selectedRange"
        @input="range"
      />
      <b-form-group label-class="mr-3" class="searchpanel-item" label-for="categories">
        <multiselect
          id="categories"
          class="mb-3"
          :value="search.filter"
          placeholder="Filtruj po kategorii / Podwykonawcy"
          label="name"
          track-by="id"
          group-values="list"
          group-label="category"
          :group-select="false"
          :options="options"
          :multiple="true"
          :max="8"
          style="min-width: 300px;"
          @input="updateFilter"
        ></multiselect>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import DatepickerWithDropdown from "@/components/DatepickerWithDropdown";

export default {
  name: "BillsSearchPanel",
  components: { DatepickerWithDropdown },
  data() {
    return {
      options: [],
      subcontractors: [],
      selectedCategories: [],
      selectedSubcontractors: []
    };
  },
  computed: {
    ...mapGetters("bills", ["search", "selectedRange", "categories"]),
    ...mapGetters("subcontractors", ["availableSubcontractors"])
  },
  created() {
    let loadQueue = [this.loadAvailable(), this.loadCategories()];
    Promise.all(loadQueue).then(() => {
      this.options = [
        { category: "Podwykonawca", list: this.availableSubcontractors },
        { category: "Kategorie", list: this.categories }
      ];
    });
  },
  methods: {
    ...mapActions("bills", ["loadCategories"]),
    ...mapActions("subcontractors", ["loadAvailable"]),
    range(range, selected) {
      if (range) {
        this.$store.commit("bills/range", {
          selected: selected,
          range: range
        });
        this.$emit("filtersChanged");
      }
    },
    updateFilter(value) {
      this.$store.commit("bills/search", {
        type: "filter",
        value: value
      });
      this.$emit("filtersChanged");
    }
  }
};
</script>